import React from 'react';
import { Icon } from 'semantic-ui-react';
import './Landing.css';

const ResultCard = ({ event, isNew }) => {
  const { event_day, event_month, event_name, event_location, event_club, event_results } = event;

  // Extract first 3 letters of month for display
  const monthShort = event_month ? event_month.substring(0, 3).toUpperCase() : '';

  // Link directly to the HTML results file
  const resultsLink = event_results && event_results !== 'available after competition'
    ? event_results
    : '#';

  return (
    <a
      href={resultsLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <div className="result-card">
        <div className="result-date-badge">
          <div className="result-date-month">{monthShort}</div>
          <div className="result-date-day">{event_day}</div>
        </div>

        <div className="result-content">
          <div className="result-title">{event_name || event_club}</div>
          <div className="result-location">
            <Icon name="map marker alternate" size="small" />
            {event_location}
          </div>
        </div>

        <div className="result-badges">
          {isNew && <span className="new-badge">New</span>}
          <Icon name="arrow right" />
        </div>
      </div>
    </a>
  );
};

export default ResultCard;
